import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import { provideFeedback } from '../google_api/googleSearchService';

const FeedbackButtons = ({ result }) => {
  const handleFeedback = (isPositive) => {
    provideFeedback(result, isPositive);
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', mt: 1 }}>
      <Tooltip title="This is a good match">
        <IconButton 
          size="small" 
          color="primary"
          onClick={() => handleFeedback(true)}
        >
          <ThumbUpIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="This is not a good match">
        <IconButton 
          size="small" 
          color="error"
          onClick={() => handleFeedback(false)}
        >
          <ThumbDownIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default FeedbackButtons; 